import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "./Header";
import Backdrop from "../../../Components/UI/Backdrop/Backdrop";
import Spinner from "../../../Components/common/Spinner/Spinner";
import Field from "../../Settings/Content/Components/Field";

import {
  RequestGetSpamSettings,
  RequestSetSpamSettings,
  RequestToggleSpamSettings,
} from "../../../store/actions/mailGatewayActions";

const SpamSettingsForm = ({ selectedProduct, selectedHost }) => {
  const dispatch = useDispatch();

  const [settings, setSettings] = useState({
    score_align: 0,
    precheck_mailbox_for_delivery: "",
    general_spam_configuration: "",
  });

  const spamSettings = useSelector((state) => state.mailGateway.spamSettings);
  const spamSettingsLoading = useSelector((state) => state.mailGateway.spamSettingsLoading);
  const setSpamSettingsLoading = useSelector((state) => state.mailGateway.setSpamSettingsLoading);

  const spamSettingsStatus = spamSettings.spam_settings_status === "1";

  useEffect(() => {
    dispatch(RequestGetSpamSettings(selectedHost));
  }, [dispatch, selectedHost]);

  useEffect(() => {
    if (spamSettings && spamSettings.score_align && selectedHost) {
      setSettings((prevSettings) => ({
        ...prevSettings,
        score_align: Number(spamSettings.score_align),
        precheck_mailbox_for_delivery: spamSettings.precheck_mailbox_for_delivery,
        general_spam_configuration: spamSettings.general_spam_configuration,
      }));
    }
  }, [spamSettings, selectedHost]);

  const toggleSpamSettingsHandler = () => {
    if (spamSettingsLoading) return;
    dispatch(
      RequestToggleSpamSettings({
        host: selectedHost,
        spam_settings_status: spamSettingsStatus ? "0" : "1",
      }),
    );
  };

  const inputChangeHandler = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === "score_align") {
      if (value < 0) {
        value = 0;
      } else if (value > 10) {
        value = 10;
      }
      value = Number(value);
    }

    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const checkSaveButtonDisabled = () => {
    const keys = Object.keys(settings);
    for (const key of keys) {
      if (key === "spam_settings_status") continue;
      else if (key === "score_align" && settings[key] === Number(spamSettings[key])) continue;
      else if (settings[key] !== spamSettings[key]) return false;
    }
    return true;
  };

  const saveHandler = () => {
    if (spamSettingsLoading || setSpamSettingsLoading) return;

    const { url_settings_status, ...subOptions } = settings;
    dispatch(RequestSetSpamSettings({ host: selectedHost, reqBody: subOptions }));
  };

  return (
    <>
      <Header
        selectedProduct={selectedProduct}
        selectedHost={selectedHost}
        toggleProps={{
          show: true,
          text: "Status",
          active: spamSettingsStatus,
          onClick: toggleSpamSettingsHandler,
        }}
      />
      <form className="products-body-form">
        <div className="products-body-form__line" style={{ gap: "50px", marginBottom: "8px" }}>
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Pre-check Mailbox for Delivery
              {/* <Tooltip
                text={"If enabled, it will be checked whether the url is a download link."}
              /> */}
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="precheck_mailbox_for_delivery"
                  checked={settings.precheck_mailbox_for_delivery === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="precheck_mailbox_for_delivery"
                  checked={settings.precheck_mailbox_for_delivery === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
        </div>

        <div className="products-body-form__line" style={{ gap: "50px", marginBottom: "8px" }}>
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              General Spam Configuration
              {/* <Tooltip
                text={"If enabled, it will be checked whether the url is a download link."}
              /> */}
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="general_spam_configuration"
                  checked={settings.general_spam_configuration === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Strict</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="general_spam_configuration"
                  checked={settings.general_spam_configuration === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Soft</p>
              </label>
            </div>
          </div>
        </div>

        <div className="products-body-form__line">
          <div className="mailing__content__security m-b-20">
            <Field
              label="Score Align"
              width="100px"
              name="score_align"
              value={settings.score_align}
              onChange={inputChangeHandler}
              type="number"
            />
          </div>
        </div>

        <button
          type="button"
          className="save-button primary-button"
          onClick={saveHandler}
          disabled={checkSaveButtonDisabled()}>
          {spamSettingsLoading || setSpamSettingsLoading ? (
            <Spinner width={12} height={12} />
          ) : (
            "Save Settings"
          )}
        </button>

        <Backdrop
          spinner={false}
          absolute
          show={!spamSettingsStatus}
          message="Spam settings are inactive! Please click on the status button at the header to activate spam settings."
          messageStyle={{ paddingTop: 0 }}
        />
      </form>
    </>
  );
};

export default SpamSettingsForm;
